import { call } from '../@';

const resumeSession = async (sessionId: string) =>
	call('sessions-resume', { sessionId }).catch(() => sessionStorage.removeItem('sessionId'));

export default resumeSession;
